export default {
  nullFormat(field) {
    if (field === null) return true
    if (field.trim() === '') return true
    return field === undefined;
  },
  lengthFormat(field, length) {
    return field.toString().length !== length;
  },
  monthFormat(mm) {
    const descmonth = mm.toString().substring(4, 6)
    let result
    switch (descmonth) {
      case '01':
        result = 'มกราคม'
        break
      case '02':
        result = 'กุมภาพันธ์'
        break
      case '03':
        result = 'มีนาคม'
        break
      case '04':
        result = 'เมษายน'
        break
      case '05':
        result = 'พฤษภาคม'
        break
      case '06':
        result = 'มิถุนายน'
        break
      case '07':
        result = 'กรกฎาคม'
        break
      case '08':
        result = 'สิงหาคม'
        break
      case '09':
        result = 'กันยายน'
        break
      case '10':
        result = 'ตุลาคม'
        break
      case '11':
        result = 'พฤศจิกายน'
        break
      case '12':
        result = 'ธันวาคม'
        break
      default:
        result = ''
        break
    }
    return `${Number(mm.toString().substring(6, 8)).toString()} ${result} ${mm.toString().substring(0, 4)}`
  },
}
